import { createAction } from '@gef-ui/utils/fsaActions';
import allPass from "ramda/es/allPass";
import any from "ramda/es/any";
import compose from "ramda/es/compose";
import eqProps from "ramda/es/eqProps";
import prop from "ramda/es/prop";
import when from "ramda/es/when";
import dotPath from "ramda-extension/es/dotPath";
import isNotNil from "ramda-extension/es/isNotNil";
import notEqual from "ramda-extension/es/notEqual";
import { actionTypes } from '../constants';
import { getConfig, getToastr } from '../selectors';
const notPreventsDuplicates = compose(notEqual(false), dotPath('options.preventDuplicates'));
const haveToasts = when(isNotNil, compose(isNotNil, prop('toasts')));
const isDuplicateToast = allPass([
    eqProps('title'),
    eqProps('message'),
    eqProps('type')
]);
/**
 * Handles display of Toastr container with provided options
 *
 * @documented
 * @category Action
 * @example
 *
 * dispatch(addToast({
 * 	type: toastTypes.SUCCESS,
 * 	message: 'Message content',
 * 	position: toastrPositions.TOP_CENTER,
 * 	closeable: true,
 * 	withTimeout: true,
 *	timeout: 20000,
 * 	renderIcon: true,
 *	options: {
 *  	preventDuplicates: false,
 * 	}
 * }));
 *
 */ export const addToast = (toast)=>(dispatch, getState)=>{
        const state = getState();
        const toastr = getToastr(state);
        const config = getConfig(state);
        let isDuplicate = false;
        if (config.preventDuplicates && notPreventsDuplicates(toast) && haveToasts(toastr)) {
            isDuplicate = any(isDuplicateToast(toast), toastr.toasts);
        }
        if (!isDuplicate) {
            dispatch(createAction(actionTypes.ADD_TOAST)(toast));
        }
    };
/**
 * Handles removal of Toastr container based on provided id
 *
 * @documented
 * @category Action
 * @example
 *
 * dispatch(removeToast({ id: 'toastId' }));
 *
 */ export const removeToast = createAction(actionTypes.REMOVE_TOAST);
export default {
    addToast,
    removeToast
};
